import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  users: [], // list of users
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
};

const userListSlice = createSlice({
  name: "userList",
  initialState,
  reducers: {
    fetchUsersStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchUsersSuccess(state, action) {
      state.users = action.payload.users;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchUsersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteUserStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteUserSuccess(state, action) {
      state.loading = false;
      state.users = state.users.filter((user) => user.id !== action.payload);
    },
    deleteUserFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateUserStatusStart(state) {
      state.loading = false;
      state.error = null;
    },
    updateUserStatusSuccess(state, action) {
      state.loading = false;
      const updatedUser = action.payload;
      const index = state.users.findIndex((user) => user.id === updatedUser.id);
      if (index !== -1) {
        state.users[index] = updatedUser;
      }
    },
    updateUserStatusFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    resetUserList(state) {
      state.users = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure,
  resetUserList,
  deleteUserStart,
  deleteUserSuccess,
  deleteUserFailure,
  updateUserStatusStart,
  updateUserStatusFailure,
  updateUserStatusSuccess,
} = userListSlice.actions;

export default userListSlice.reducer;
